'use client';

import { c as _c } from "react/compiler-runtime";
import { useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
import { cn } from '@src/utils/tailwind';
export const SKUSelectionRailItemBorder = t0 => {
  const $ = _c(8);
  const {
    columnsDesktop,
    railSlug,
    sku
  } = t0;
  let t1;
  if ($[0] !== railSlug) {
    t1 = state => state.groups.get(railSlug ?? "");
    $[0] = railSlug;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const group = useSKUSelectionStore(t1);
  let t2;
  if ($[2] !== columnsDesktop || $[3] !== group || $[4] !== sku) {
    const isSelected = sku ? group?.includes(sku) ?? false : false;
    t2 = cn("absolute -inset-1 rounded-[14px] hover:outline hover:outline-[3px] hover:outline-bodi-black-text lg:rounded-[30px]", {
      "ring ring-bodi-accent-deep-500  hover:outline-bodi-accent-deep-500": isSelected
    }, {
      "lg:rounded-[14px]": (columnsDesktop ?? 0) >= 5
    });
    $[2] = columnsDesktop;
    $[3] = group;
    $[4] = sku;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className={t2} />;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};